var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResponse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI icon/undo/light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M18.4632 14.2974C17.4689 10.5863 13.6543 8.38394 9.94322 9.37833C7.85972 9.9366 6.27946 11.3773 5.45982 13.2036L6.79305 12.8422C7.28168 12.7097 7.78517 12.9984 7.91763 13.487C8.05009 13.9757 7.76136 14.4792 7.27274 14.6116L4.36656 15.3995C4.33413 15.4102 4.301 15.4192 4.2673 15.4264L3.89541 15.5272C3.66031 15.5909 3.40952 15.5585 3.19839 15.437C2.98727 15.3155 2.83317 15.115 2.77013 14.8797L1.86447 11.4997C1.73344 11.0107 2.02364 10.5081 2.51265 10.377C3.00166 10.246 3.5043 10.5362 3.63533 11.0252L3.93457 12.142C5.00443 9.98662 6.94105 8.28475 9.46872 7.60746C14.1578 6.35102 18.9777 9.13375 20.2341 13.8229C20.3651 14.3119 20.0749 14.8145 19.5859 14.9455C19.0969 15.0766 18.5943 14.7864 18.4632 14.2974Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponse);
export default __webpack_public_path__ + "static/media/response.6b640cc14374532fddc7fab253d6d702.svg";
export { ForwardRef as ReactComponent };